import CommonUtils from "@/common-utils";
import Criteo from "@/criteo";
import { CriteoVO } from "@/vo/criteo.vo";
import store from "@/store/store";
import axios from 'axios';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter)

let routes;

switch (process.env.VUE_APP_SYSTEM_LOCALE) {
  case 'ko':
    routes = require('./routes.ko').default;
    break;
  case 'global':
    routes = require('./routes.global').default;
    break;
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, savedPosition) => { // 링크 이동 시 스크롤 top으로
    return new Promise((resolve) => {
      if (to.hash) {
        resolve({ selector: to.hash });
      } else if (savedPosition) {
        resolve(savedPosition);
      } else {
        resolve({ x: 0, y: 0 });
      }
    })
  }
});

router.beforeEach((to, from, next) => {
  if (to.fullPath.indexOf('/http') > -1) { // 외부 링크 ㄱㄱ
    location.href = to.fullPath.replace(/^.*\/http/, 'http');
    return;
  }
  // teleport 초기화
  const destination = document.getElementById("destination");
  if(destination) {
    destination.innerHTML = "";
  }

  // 외부 쿼리 스트링 로컬스토리지에 저장
  CommonUtils.processExternalQueryString(to.query);

  if (to.meta.title) { // 브라우저 제목
    CommonUtils.setDocumentTitle(to.meta.title);
  } else {
    CommonUtils.setDocumentTitle();
  }

  if (to.meta.description) {
    CommonUtils.setMetaDiscription(to.meta.description);
  } else {
    CommonUtils.setMetaDiscription();
  }

  // 파이어베이스 page_view 수집요청
  CommonUtils.sendPageViewEventLog(router.app.$root, to);

  store.commit("fromRouteName", from.name);

  if (!to.meta.auth) { // 인증 no필요
  const query = to.query;
  query.fromUrl = from.fullPath;
    next()
    return;
  }
 
  axios.get('/login/ping')
    .then(r => {
      if (r.data as string == 'pong') {
        const params = to.params;
        params.fromName = from.name || 'Main';
        next();
      } else {
        
        Vue.prototype.$session && Vue.prototype.$session.destroy();
        const params = to.params;
        params.toName = to.name || 'Main';
        next({ name: 'Login', params: params });
      }
    });
});

router.afterEach((to) => {
  if(CommonUtils.isSystemLocale('ko') == false) {
    return;
  }

  // 크리테오 메인페이지 호출
  Criteo.putQuery({
    path : to.name,
    oneTag : Criteo.criteoTags.HOMEPAGE_TAG
  } as CriteoVO);

  // 장바구니, 결제완료, 회원가입은 제외
  const exceptRouteNames = ['PaymentComplete', 'OrderCart', 'SignUp4'] as Array<string>;

  if(exceptRouteNames.includes(to.name || '')) {
    return;
  }

  // 네이버 로그 분석 스크립트
  const _window = (window as any);
  const wcs = _window.wcs;
  if (wcs) {
    wcs.inflow("zikoo.co.kr");
    _window.wcs_do(_window._nasa);
    _window._nasa = {};
  }
  
  //console.log(Criteo.putQuery(Criteo.getOneTag()));

});

export default router
